document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-information .rte').forEach((description) => {
    const walker = document.createTreeWalker(description, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      node.nodeValue = node.nodeValue.replace(/\\n/g, ' ').replace(/\s{2,}/g, ' ');
    });
    description.querySelectorAll('p, div').forEach((element) => {
      if (!element.textContent.trim() && !element.querySelector('img, table, video')) element.remove();
    });
  });
});
